import {
  PLATFORM_AUDIT_ACTION_KEYS,
  platformAuditActionLabel,
} from '../dashboard/platform-audit-action-labels';

/**
 * Phase 12.7a — the options rendered in the Action filter (D-1).
 *
 * ── Derived, never hand-typed (§5) ─────────────────────────────────────────
 * Built from the existing label map's keys, so the control cannot drift into
 * offering a value the backend would reject. The label comes from the same
 * `platformAuditActionLabel()` the table and the Dashboard use, so one action
 * reads identically everywhere.
 *
 * ── Why this is a subset of the backend whitelist, deliberately ────────────
 * The backend validates against the FULL emitted vocabulary
 * (`PLATFORM_AUDIT_ACTIONS`), which later phases have grown beyond the sixteen
 * actions this label map names. That asymmetry is safe in the only direction
 * that matters: every value this control can offer is accepted by the server.
 * An action the map does not yet name is simply not offered as a *filter* in
 * v1.0 — consistent with D-1's deliberately small filter set — while still
 * *rendering* legibly wherever it appears, via the label fallback.
 */
export interface AuditActionOption {
  value: string;
  label: string;
}

export const PLATFORM_AUDIT_ACTION_OPTIONS: readonly AuditActionOption[] = [
  ...PLATFORM_AUDIT_ACTION_KEYS,
]
  .map((value) => ({ value, label: platformAuditActionLabel(value) }))
  .sort((a, b) => a.label.localeCompare(b.label));

/** Guards a URL-supplied action so a hand-edited query string cannot inject one. */
export function isKnownAuditAction(action: string): boolean {
  return PLATFORM_AUDIT_ACTION_OPTIONS.some((o) => o.value === action);
}
